import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { PartiesState } from './types';
import { RootState } from '@/types';

export const state: PartiesState = {
    data: {
      data: [],
      links: {},
      metadata: {},
    },
    loading: true,
    error: false,
};

const namespaced: boolean = true;

export const parties: Module<PartiesState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
